import * as React from 'react';
import { Field } from 'redux-form';
import SelectControl from '../SelectControl';

const childTitleList = [
  { label: 'Master', value: 'Master' },
  { label: 'Miss', value: 'Miss' },
];

const adultTitleList = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Master', value: 'Master' },
  { label: 'Dr', value: 'Dr' },
  { label: 'Prof', value: 'Prof' },
  { label: 'Rev', value: 'Rev' },
  { label: 'Cpt', value: 'Cpt' },
  { label: 'Sir', value: 'Sir' } ,
  { label: 'Dame', value: 'Dame' },
  { label: 'Lord', value: 'Lord' },
];

interface IProps {
  name: string;
  validate?: any;
  type: string;
  disabled?: boolean;
}

export default class TitleField extends React.Component<IProps> {
  public render() {
    const { name, validate, type, disabled } = this.props;

    let component = null;

    switch (type) {
      case 'child':
        component = (
          <Field
            name={name}
            placeholder={'Title'}
            component={SelectControl}
            options={childTitleList}
            validate={validate}
            disabled={disabled}
          />
        );
        break;
      default:
        component = (
          <Field
            name={name}
            placeholder={'Title'}
            component={SelectControl}
            options={adultTitleList}
            validate={validate}
            disabled={disabled}
          />
        );
        break;
    }
    return (
      <div className="max-title-input">
        {component}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/TitleField/index.tsx